import {
  Page,
  PageBody,
  PageHeader,
  PageHeaderTitle,
  PageHeaderActions,
  Stack,
  Banner,
  Select,
  PageLoader,
} from '@customerio/pluma-components/react';
import { PageTitle } from '@/components/page-title';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { useEnvHealth, useWorkspaceHealthSimulation } from '@/features/workspace-health';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { HealthOverview } from './components/health-overview';

export function HealthPage() {
  const isLocalDev = import.meta.env.DEV as boolean;
  const { simulate, handleSetSimulate } = useWorkspaceHealthSimulation();

  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;
  const healthQuery = useEnvHealth(workspaceId, simulate);

  if (healthQuery.isLoading) {
    return <PageLoader label="Loading workspace health data" />;
  }

  return (
    <>
      <PageTitle title="Workspace Performance" />
      <Page isFullScreen w="full">
        <PageHeader>
          <PageHeaderTitle>Workspace Performance</PageHeaderTitle>
          {isLocalDev ? (
            <PageHeaderActions>
              <Select
                ariaLabel="Simulate"
                value={simulate ?? 'off'}
                size="sm"
                onChange={(value) =>
                  handleSetSimulate(
                    value === 'off' ? undefined : (value as ServicesApiGetEnvHealthQueryParams['simulate']),
                  )
                }
                options={[
                  { value: 'off', label: 'Live' },
                  { value: 'healthy', label: 'Healthy' },
                  { value: 'busy', label: 'Busy' },
                  { value: 'degraded', label: 'Degraded' },
                ]}
              />
            </PageHeaderActions>
          ) : null}
        </PageHeader>
        <PageBody>
          <Stack gap="400" pb="200">
            {healthQuery.isError ? (
              <Banner variant="error" title="Error">
                Unable to load health data. Please try again later.
              </Banner>
            ) : null}

            {healthQuery.data != null ? <HealthOverview /> : null}
          </Stack>
        </PageBody>
      </Page>
    </>
  );
}
